import { cx, css } from 'emotion';
import {
	helvetica,
	aqua,
	grey,
	pink,
	blue,
	lightGrey,
	darkGrey,
	museo900,
	mobileMaxWidthBreakpoint,
	mobileMinWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
	desktopMaxWidthBreakpoint,
} from 'inside-out/global-styles';

import DropDownGreyIcon from 'inside-out/images/drop-down-grey-icon.svg';

export const errorStyle = css({
	color: pink,
	fontWeight: 'bold',
	textTransform: 'uppercase',
	fontSize: '12px',
});

export const wrapperStyle = topMargin => css({
	...helvetica,
	position: 'sticky',
	top: `${32 + topMargin}px`,
	zIndex: 3,
	height: '70px',
	borderBottom: `1px solid ${lightGrey}`,
	background: '#fff',

	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		top: `${topMargin}px`,
	},
});

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
});

export const leftStyle = css({
	display: 'flex',
	alignItems: 'center',
});

export const headerLinksStyle = css({
	paddingLeft: '39px',
	display: 'flex',
	alignItems: 'center',
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		display: 'none',
	},
});

const headerLinkCommonStyle = (height, noMargin) => css({
	height,
	display: 'flex',
	alignItems: 'center',
	fontWeight: 500,
	color: grey,
	fontSize: '14px',
	textDecoration: 'none',
	cursor: 'pointer',
	...(!noMargin && {
		'&:not(:last-child)': {
			marginRight: '30px',
		},
	}),
});

export const headerLinkStyle = submenu => cx(
	headerLinkCommonStyle(submenu ? 40 : 40, submenu),
	css({
		'&:hover, &:focus, &:focus-within': {
			color: darkGrey,
		},
	})
);

export const submenuStyle = css({
	visibility: 'hidden',
	opacity: 0,
	position: 'absolute',
	top: '100%',
	left: '0',
	transform: 'perspective(400) rotate3d(1,0,0,-45deg)',
	transformOrigin: '50% 0',
	transition: 'all 0.2s ease-in-out',
	padding: '8px 16px',
	minWidth: '230px',
	border: `1px solid ${lightGrey}`,
	borderRadius: '4px',
	background: '#FFFFFF',
	boxShadow: '0 6px 12px 0 rgba(32,33,39,0.08)',
});

export const headerMenuLinkStyle = cx(
	headerLinkCommonStyle(46),
	css({
		position: 'relative',
		'&:hover, &:focus, &:focus-within': {
			outline: 'none',
			color: darkGrey,
			[`.${submenuStyle}`]: {
				visibility: 'visible',
				opacity: 1,
				transform: 'perspective(400) rotate3d(0,0,0,0)',
			},
		},
		'&:after': {
			display: 'block',
			content: '" "',
			width: '8px',
			height: '6px',
			marginLeft: '8px',
			background: `url(${DropDownGreyIcon}) no-repeat center bottom`,
			backgroundSize: 'contain',
		},
	})
);

export const logoStyle = css({
	display: 'table-cell',
	'& #logoDesktop': {
		width: '158px',
		height: '54px',
	},
	'& #logoMobile': {
		display: 'none',
		height: '36px',
	},
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		'& #logoDesktop': {
			display: 'none',
		},
		'& #logoMobile': {
			display: 'block',
		},
	},
});

export const rightStyle = css({
	flexShrink: 0,

	'a': {
		color: grey,
		fontSize: '14px',
		fontWeight: 500,
		textDecoration: 'none',
	},
	'& #hamburger': {
		display: 'none',
	},
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		'& #header-right': {
			display: 'none',
		},
		'& #hamburger': {
			display: 'inline-block',
			width: '24px',
			height: '24px',
		},
	},
});

export const riskButtonStyle = css({
	...museo900,
	background: aqua,
	border: 'none',
	color: '#fff',
	fontSize: '14px',
	letterSpacing: '0.58px',
	borderRadius: '4px',
	textTransform: 'uppercase',
	padding: '9px 11px 5px 11px',
	marginLeft: '24px',
});

export const myAccountDropDowWrapperStyle = css({
	position: 'relative',
	'& > a': {
		display: 'table',
		position: 'relative',
		paddingRight: '22px',
		'& > div': {
			display: 'table-cell',
			verticalAlign: 'middle',

			'&:first-child': {
				paddingRight: '10px',
				'& div': {
					width: '18px',
					height: '18px',
					position: 'relative',
					background: blue,
					border: `2px solid ${lightGrey}`,
					borderRadius: '9px',
				},
			},
		},
		'&:after': {
			position: 'absolute',
			right: '0',
			top: '50%',
			transform: 'translateY(-50%)',
			content: '" "',
			display: 'block',
			width: '12px',
			height: '7px',
			background: `url(${DropDownGreyIcon}) no-repeat center center`,
		},
		'&:focus': {
			pointerEvents: 'none',
			'&  + div': {
				opacity: '1',
				visibility: 'visible',
				pointerEvents: 'auto',
			},
		},
	},
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		display: 'none',
	},
});

export const myAccountDropDownStyle = css({
	opacity: '0',
	visibility: 'hidden',
	transition: 'visibility 0.5s',
	position: 'absolute',
	top: '26px',
	background: '#fff',
	right: '0',
	boxShadow: 'rgba(0,0,0,0.20) 0 17px 24px 0',
	width: '230px',
	borderRadius: '4px',
	border: `1px solid ${lightGrey}`,
	'& a': {
		display: 'block',
		padding: '16px',
		color: darkGrey,
		fontSize: '14px',
		lineHeight: '14px',
		verticalAlign: 'middle',
		'& span': {
			verticalAlign: 'middle',
			width: '20px',
			marginRight: '10px',
			display: 'inline-block',
		},
		'&:last-child': {
			position: 'relative',
			color: grey,
			'&:after': {
				content: '" "',
				position: 'absolute',
				top: '0',
				left: '4%',
				width: '92%',
				height: '1px',
				background: lightGrey,
				display: 'block',
			},
		},
	},
});



// WEBPACK FOOTER //
// ./src/components/shared/header/header.styles.js